import { countColumn, DataTableColumn, textColumn } from '../../../shared/components/DataTable'
import { getAcronym } from '../../../shared/utils/acronym'
import { toListLabel } from '../../../shared/utils/displayValue'
import { StrategicImperative } from '../../../shared/queries/strategicImperatives'
import { getLinkedActivityCount, getLinkedValueMessageCount } from './StrategicImperativeTable.helpers'
import { StrategicImperativeColumnId, StrategicImperativeDisplayNames } from './StrategicImperativeTable.types'

type StrategicImperativeColumn = DataTableColumn<StrategicImperative, StrategicImperativeColumnId>

export const getStrategicImperativeColumns = ({
    activities,
    valueMessages,
}: StrategicImperativeDisplayNames): StrategicImperativeColumn[] => [
    textColumn('name', 'Title', (row: StrategicImperative) => row.name, { width: 500 }),
    textColumn('audiences', 'Audiences', (row: StrategicImperative) => toListLabel(row.audiences), {
        width: 275,
    }),
    countColumn('linkedActivities', `Linked ${getAcronym(activities)}`, getLinkedActivityCount, {
        tooltip: `Linked ${activities}`,
        width: 230,
    }),
    countColumn('linkedValueMessages', `Linked ${getAcronym(valueMessages)}`, getLinkedValueMessageCount, {
        tooltip: `Linked ${valueMessages}`,
        width: 200,
    }),
]
